import { useEffect, useRef, useState } from 'react';

const PRESET_ICONS = ['🙌', '🎵', '🎶', '🙏', '📖', '✝', '📢', '📜', '🕊', '✢', '♫', '🕯', '👏', '⛪', '🎤', '🍞'];

const POPOVER_WIDTH = 208;
const POPOVER_HEIGHT_ESTIMATE = 150;
const VIEWPORT_MARGIN = 8;

export default function WorshipIconPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (icon: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState<{ top: number; left: number } | null>(null);
  const rootRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const openPicker = () => {
    const rect = triggerRef.current?.getBoundingClientRect();
    if (!rect) return;

    const openUpward = rect.bottom + VIEWPORT_MARGIN + POPOVER_HEIGHT_ESTIMATE > window.innerHeight;
    const left = Math.min(rect.left, window.innerWidth - POPOVER_WIDTH - VIEWPORT_MARGIN);
    const top = openUpward ? rect.top - VIEWPORT_MARGIN - POPOVER_HEIGHT_ESTIMATE : rect.bottom + VIEWPORT_MARGIN;

    setPosition({ top: Math.max(top, VIEWPORT_MARGIN), left: Math.max(left, VIEWPORT_MARGIN) });
    setOpen(true);
  };

  useEffect(() => {
    if (!open) return;
    const close = () => setOpen(false);
    const handleClickOutside = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) close();
    };
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [open]);

  return (
    <div className="manage-worship-icon-picker" ref={rootRef}>
      <button
        type="button"
        ref={triggerRef}
        className="manage-worship-icon-box manage-worship-icon-trigger"
        onClick={() => (open ? setOpen(false) : openPicker())}
        title="아이콘 선택">
        {value || '＋'}
      </button>
      {open && position && (
        <div
          className="manage-worship-icon-popover"
          style={{ top: position.top, left: position.left }}>
          <div className="manage-worship-icon-grid">
            {PRESET_ICONS.map((icon) => (
              <button
                key={icon}
                type="button"
                className={`manage-worship-icon-option ${value === icon ? 'is-selected' : ''}`}
                onClick={() => {
                  onChange(icon);
                  setOpen(false);
                }}>
                {icon}
              </button>
            ))}
          </div>
          <input
            className="manage-worship-icon-custom-input"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="직접 입력"
            maxLength={4}
          />
        </div>
      )}
    </div>
  );
}
